// `chatMessage.sender` (and agentStep's agentName) changed from the literal 'Agent' to the real
// responding agent's name — websocket.md, 2026-08-16. Maps the raw identifier to a human-readable
// label for chat bubbles; falls back to the raw sender for anything not yet listed here, so a new
// agent added BE-side without an FE deploy still shows *something* meaningful.
const AGENT_DISPLAY_NAME: Record<string, string> = {
  JiraAgentV2: 'Jira Agent',
  TrelloAgent: 'Trello Agent',
  StandaloneAgent: 'Standalone Agent',
  WizardAgent: 'Wizard',
  IntegrationAgent: 'Integrations Agent',
  SimpleCoordinator: 'MFlow Agent',
};

export function getAgentDisplayName(sender: string): string {
  return AGENT_DISPLAY_NAME[sender] ?? sender;
}
